export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5144.a6c19e44.jpg";